import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=487b2dde&scoped=true"
import script from "./Combobox.vue?vue&type=script&lang=js"
export * from "./Combobox.vue?vue&type=script&lang=js"
import style0 from "./Combobox.vue?vue&type=style&index=0&id=487b2dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b2dde",
  null
  
)

export default component.exports